import {Component, HostListener, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {LangChange} from '../../../../../lang-change';
import {Utils} from '../../../../../common/services/Utils';
import {Language} from '../../../../../common/models/language';
import {Principal} from '../../../../../common/services/principal';
import {PsServiceTypeEnum, PublicServicesService} from '../../../../admin/services/public-services.service';
import {DiplomaXml} from './diploma-xml';

@Component({
  selector: 'app-eds-sign-modal',
  templateUrl: './eds-sign-modal.component.html',
  styleUrls: ['./eds-sign-modal.component.scss']
})
export class EdsSignModalComponent extends LangChange implements OnInit, OnDestroy {

  langId: number;
  // appId: number;
  xmlForSign: string;
  signedXml: string;
  timer: any;
  diplomaXml: DiplomaXml;
  serviceType: PsServiceTypeEnum;
  fd: FormData;

  constructor(public dialogRef: MatDialogRef<EdsSignModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private utils: Utils,
              private principal: Principal,
              private translateService: TranslateService,
              private psService: PublicServicesService) {
    super(translateService);
  }

  ngOnInit() {
    // this.appId = this.data.appId;
    this.xmlForSign = this.data.xmlForSign;
    this.diplomaXml = this.data.diplomaXml;
    this.serviceType = this.data.serviceType;
    this.fd = this.data.fd;
    this.langId = Language.getCurrentLanguage().id;
    this.timer = setInterval(() => {
      this.signedXml = ((document.getElementById('signedXml') as HTMLInputElement).value);
      if (this.signedXml && this.signedXml.length) {
        this.sendSignedXML();
      }
    }, 500);
  }

  sendSignedXML() {
    if (this.diplomaXml && this.diplomaXml.id) {
      clearInterval(this.timer);
      this.utils.blockStart(null);
      this.diplomaXml.xml = this.signedXml;
      if (this.serviceType === PsServiceTypeEnum.DiplomaDuplicate) {
        this.fd.append('app', JSON.stringify(this.diplomaXml));
      }
      this.psService.sendSignedXML(this.diplomaXml, this.serviceType, this.fd).subscribe(
        (data) => {
          if (data.status === 'SUCCESS') {
            this.utils.notifySuccess(this.translateService.instant('saved'), null);
          } else {
            if (data.description) {
              this.utils.notifyError(this.translateService.instant(data.description), null);
            } else {
              this.utils.notifyError(this.translateService.instant('error_occurred'), null);
            }
          }
          this.utils.blockStop();
          this.dialogRef.close();
        },
        error => {
          this.utils.notifyError(this.translateService.instant('error_occurred'), null);
          console.log(error);
          this.utils.blockStop();
          this.dialogRef.close();
        }
      );
    } else if (this.diplomaXml) {
      this.diplomaXml.xml = this.signedXml;
      this.dialogRef.close('ok');
    }
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close();
  }

  onLangChange(langCode): void {
    this.langId = langCode.id;
    this.changeLang();
  }

  changeLang() {
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/public-services/eds-sign/eds-sign-modal.component.ts